<button
  [type]="ppType"
  ppTooltip
  [ppTitle]="ppTooltipTitle"
  id="{{ ppId }}"
  [ngClass]="class"
  (click)="action($event)"
  [style.cursor]="ppDisabled ? 'not-allowed' : 'pointer'"
>
  <pp-spinner
    class="button__spinner"
    [ppButton]="true"
    [ppLight]="lightSpinner"
    [ppHidden]="!ppIsLoading()"
  />

  <span class="button__text" [class.button__text--hidden]="ppIsLoading()">
    <ng-content></ng-content>
  </span>
</button>
